export const executionClient = http => {
  const getExecution = async executionId => {
    const res = await http.get(`/executions/${encodeURIComponent(executionId)}`)
    return res && res.execution
  }
  const startStep = async (executionId, stepId) => {
    const res = await http.post(`/executions/${encodeURIComponent(executionId)}/step/${encodeURIComponent(stepId)}/start`)
    return res && res.execution
  }
  const prepStep = async (executionId, stepId) => {
    const res = await http.post(`/executions/${encodeURIComponent(executionId)}/step/${encodeURIComponent(stepId)}/prep`)
    return res && res.execution
  }
  const completeStep = async (executionId, stepId) => {
    const res = await http.post(`/executions/${encodeURIComponent(executionId)}/step/${encodeURIComponent(stepId)}/complete`)
    return res && res.execution
  }
  const adjustStepTime = async (executionId, stepId, delta) => {
    const res = await http.post(`/executions/${encodeURIComponent(executionId)}/step/${encodeURIComponent(stepId)}/adjust_time`, { delta })
    return res && res.execution
  }
  return { getExecution, startStep, prepStep, completeStep, adjustStepTime }
}
